// extracted by mini-css-extract-plugin
module.exports = {"root":"FormActions_root__3i9Sn","xxs":"FormActions_xxs__3SxcF","xs":"FormActions_xs__1doHh","sm":"FormActions_sm__2ok9f","md":"FormActions_md__213X0","lg":"FormActions_lg__30ewb"};